// extracted by mini-css-extract-plugin
export var banner = "CookieAcceptanceBanner-module--banner--pVtJJ";
export var bannerContainer = "CookieAcceptanceBanner-module--bannerContainer--2NJKh";
export var label = "CookieAcceptanceBanner-module--label--1rSIu";
export var text = "CookieAcceptanceBanner-module--text--36fxI";
export var acceptBtn = "CookieAcceptanceBanner-module--acceptBtn--3soc7";